<template>
    <form class="search__form form">
        <div class="form__input-wrapper" id="search-form">
            <input
                class="form__input"
                id="input"
                type="text"
                :placeholder="placeholder"
                @paste="onPaste"
                v-model="search"
            />
            <button
                :class="buttonClass"
                type="button"
                @click="onButtonClick"
            >
                {{ search ? 'Clear' : 'Paste' }}
            </button>
        </div>
        <button
            class="button button--download"
            type="submit"
            @click.prevent="onSearchClick(true)"
        >
            Download
        </button>
        <p class="form__error" v-if="isInvalidLink">{{ errorText }}</p>
    </form>
</template>
<script>
import axios from 'axios'
import experimentHooks from "../experiment/experimentHooks";

let getSignedRequestBody
try {
    getSignedRequestBody = await (
        await import(
            /* webpackChunkName: "link.chunk" */
            '../utils/getSignedRequestBody.js'
        )
    ).default
} catch (error) {
    getSignedRequestBody = async (url) => {
        return { url }
    }
}

export default {
    name: 'SearchForm',
    data() {
        return {
            search: null,
            isInvalidLink: false,
            errorText: '',
        }
    },
    props: {
        placeholder: String,
    },
    methods: {
        async onSearchClick(isButtonClick) {
            if (isButtonClick) {
                this.$root.$emit('search-started', 'click')
            } else {
                this.$root.$emit('search-started', 'auto')
            }

            this.isInvalidLink = false

            this.$root.$emit('clear-results')
            this.$root.$emit('clear-error')

            if (!this.search) {
                this.showFormError('Paste the link to start searching')
                return
            }

            const isValidLink = this.checkValidLink(this.search)
            const isTiktokLink = this.search.match(/tiktok/)

            this.$root.$emit('loader-state-change', true)

            if (isValidLink) {
                if (isTiktokLink) {
                    try {
                        const reqBody = await getSignedRequestBody(
                            this.search.trim()
                        )
                        const postResponse = await axios.post(
                            `/api/convert`,
                            reqBody
                        )

                        this.$root.$emit(
                            'tt-result-received',
                            postResponse.data
                        )
                    } catch (error) {
                        if (error.response.status === 401) {
                            const e = error.response.data
                            this.$root.$emit('error-occured', e.error_message, 'Unauthorized')
                        } else if (
                            error?.message ===
                            'Request failed with status code 400'
                        ) {
                            this.$root.$emit(
                                'error-occured',
                                `The download link not found.`
                            )
                        } else {
                            this.$root.$emit(
                                'error-occured',
                                `Something went wrong, please try again.`
                            )
                        }
                    }
                } else {
                    this.$root.$emit(
                        'error-occured',
                        `Sorry, it seems that the link is not valid :( Please, try again.`
                    )
                }
            } else {
                this.showFormError('Url error. Please check again')
                this.$root.$emit('error-occured', null, this.errorText)
            }

            this.$root.$emit('loader-state-change', false)
        },
        onPaste() {
            window.setTimeout(() => {
                this.$root.$emit('input-inserted')
                this.onSearchClick(false)
            }, 100)
        },
        async onButtonClick() {
            if(!this.search) {
                try {
                    this.search = await navigator.clipboard.readText()
                    this.onPaste()
                } catch {
                    this.showFormError('Your browser does not support clipboard reading')
                }
            } else {
                this.search = '';
            }
        },
        checkValidLink(searchQuery) {
            const ttUsernameMatchRegex = /(?:(?:http|https):\/\/)/im
            return ttUsernameMatchRegex.test(searchQuery.trim())
        },
        showFormError(text, duration = 3000) {
            this.isInvalidLink = true

            setTimeout(() => {
                this.isInvalidLink = false
            }, duration);

            this.errorText = text;
        }
    },
    computed: {
        buttonClass() {
            return {
                'button button--paste': !this.search,
                'button button--clear': this.search,
            }
        }
    }
}
</script>
